import { render, staticRenderFns } from "./PurchareOrdersList.vue?vue&type=template&id=cbcfadfa&scoped=true"
import script from "./PurchareOrdersList.vue?vue&type=script&lang=js"
export * from "./PurchareOrdersList.vue?vue&type=script&lang=js"
import style0 from "./PurchareOrdersList.vue?vue&type=style&index=0&id=cbcfadfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcfadfa",
  null
  
)

export default component.exports